import {List, Record} from 'immutable';

export default class RepProfilePageCoachingPlan extends Record({
  id: undefined,
  name: undefined,
  contentDetails: List(),
  coach: undefined,
  recipient: undefined,
  start: undefined,
  end: undefined,
  completed: undefined,
  reviews: undefined,
  reviewScores: undefined,
  adHoc: undefined,
  livecoaching: undefined,
}) {
  unscheduled() {
    return this.adHoc || this.livecoaching;
  }
}

export const RepProfilePageContentDetailScore = Record({
  planId: undefined,
  contentDetailId: undefined,
  skillName: undefined,
  startScore: undefined,
  endScore: undefined,
});
